import {put, takeLatest, call} from 'redux-saga/effects';
import * as promotionService from "../../../../services/promotionService.js";
import {
    UPDATE_PROMOTION,
    UPDATE_PROMOTION_SUCCESS,
    UPDATE_PROMOTION_ERROR,
}
    from "../../../actions/menu/promotions";

function* updatePromotionSaga(action) {
    try {
        const data =  yield call(promotionService.UpdatePromotion, action.payload)
        yield put({
            type: UPDATE_PROMOTION_SUCCESS,
            payload: data
        });


    } catch (error) {
        yield put({
            type: UPDATE_PROMOTION_ERROR,error: error.data
        });
    }
}


export function* updatePromotionSagaWatcher() {
    yield takeLatest(UPDATE_PROMOTION, updatePromotionSaga);
}